document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.c_information-list[data-blog-url]');
  if (!section) return;

  const blogUrl = section.dataset.blogUrl;
  const articlesCount = Number(section.dataset.articlesCount);
  const perPage = Number(section.dataset.perPage);
  const categorySelect = section.querySelector('[data-filter-category]');
  const archiveSelect = section.querySelector('[data-filter-archive]');
  const listContainer = section.querySelector('[data-information-list]');
  const paginationContainer = section.querySelector('[data-information-pagination]');

  let cachedArticles = null;

  const fetchAllArticles = async () => {
    if (cachedArticles) return cachedArticles;

    const totalPages = Math.max(1, Math.ceil(articlesCount / perPage));

    const fetchPage = async (page) => {
      const res = await fetch(`${blogUrl}?page=${page}`);
      if (!res.ok) throw new Error(`読み込みに失敗しました（${res.status}）`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return [...doc.querySelectorAll('.c_information-list__item')];
    };

    const results = await Promise.all(
      Array.from({ length: totalPages }, (_, i) => fetchPage(i + 1))
    );

    cachedArticles = results.flat().map((item) => ({
      date: item.dataset.date,
      tags: item.dataset.tags || '',
      html: item.outerHTML,
    }));

    return cachedArticles;
  };

  const filterArticles = async (filterFn) => {
    listContainer.setAttribute('aria-busy', 'true');
    listContainer.innerHTML = '<li class="c_information-list__item"><p>読み込み中...</p></li>';
    if (paginationContainer) paginationContainer.style.display = 'none';

    try {
      const articles = await fetchAllArticles();
      updateArchiveOptions(articles);
      showPage(articles.filter(filterFn), 1);
    } catch (error) {
      const errorLi = document.createElement('li');
      errorLi.className = 'c_information-list__item';
      const errorP = document.createElement('p');
      errorP.textContent = error.message;
      errorLi.appendChild(errorP);
      listContainer.innerHTML = '';
      listContainer.appendChild(errorLi);
    } finally {
      listContainer.removeAttribute('aria-busy');
    }
  };

  const showPage = (articles, page) => {
    const totalPages = Math.ceil(articles.length / perPage);
    const pageArticles = articles.slice((page - 1) * perPage, page * perPage);

    listContainer.innerHTML = pageArticles.length > 0
      ? pageArticles.map((a) => a.html).join('')
      : '<li class="c_information-list__item"><p>該当する記事はありません。</p></li>';

    if (!paginationContainer) return;

    paginationContainer.innerHTML = totalPages > 1 ? buildPagination(page, totalPages) : '';
    paginationContainer.style.display = totalPages > 1 ? '' : 'none';

    paginationContainer.querySelectorAll('[data-page]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        showPage(articles, Number(btn.dataset.page));
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  };

  /* クライアントサイドページネーション: フィルタ適用時にJSで描画。
     c_pagination.liquid（サーバーサイド）とはHTML構造を合わせている */
  const buildPagination = (current, total) => {
    const parts = getPaginationParts(current, total);

    const prevBtn = current > 1
      ? `<a href="#" data-page="${current - 1}" class="c_pagination__item c_pagination__prev" rel="prev" aria-label="前のページ">
          <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 1L1 6L5 11" stroke="currentColor" stroke-width="2"/></svg>
        </a>`
      : '';

    const nextBtn = current < total
      ? `<a href="#" data-page="${current + 1}" class="c_pagination__item c_pagination__next" rel="next" aria-label="次のページ">
          <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1 1L5 6L1 11" stroke="currentColor" stroke-width="2"/></svg>
        </a>`
      : '';

    const pageItems = parts.map((part) => {
      if (part === '...') return '<span class="c_pagination__ellipsis c_font-en">...</span>';
      if (part === current) return `<span class="c_pagination__item is-active" aria-current="page"><span class="c_pagination__number c_font-en">${part}</span></span>`;
      return `<a href="#" data-page="${part}" class="c_pagination__item" aria-label="${part}ページへ"><span class="c_pagination__number c_font-en">${part}</span></a>`;
    }).join('');

    return `<nav class="c_pagination" aria-label="ページネーション">${prevBtn}${pageItems}${nextBtn}</nav>`;
  };

  const getPaginationParts = (current, total) => {
    if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
    const parts = [1];
    if (current > 3) parts.push('...');
    for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) {
      parts.push(i);
    }
    if (current < total - 2) parts.push('...');
    parts.push(total);
    return parts;
  };

  const updateArchiveOptions = (articles) => {
    if (!archiveSelect) return;
    const dates = [...new Set(articles.map((a) => a.date))];
    const currentValue = archiveSelect.value;
    archiveSelect.innerHTML = '<option value="">アーカイブ</option>';
    dates.forEach((date) => {
      const option = document.createElement('option');
      option.value = date;
      option.textContent = date;
      if (date === currentValue) option.selected = true;
      archiveSelect.appendChild(option);
    });
  };

  const applyFilters = () => {
    const tag = categorySelect ? categorySelect.value : '';
    const date = archiveSelect ? archiveSelect.value : '';
    filterArticles((a) => {
      const matchTag = !tag || a.tags.split(',').includes(tag);
      const matchDate = !date || a.date === date;
      return matchTag && matchDate;
    });
  };

  if (categorySelect) {
    categorySelect.addEventListener('change', applyFilters);
  }

  if (archiveSelect) {
    archiveSelect.addEventListener('change', applyFilters);
  }

  if (articlesCount > 50) {
    fetchAllArticles().then(updateArchiveOptions).catch(() => {});
  }
});
